const map = {
	"./apple.svg": 49234,
	"./aws.svg": 80409,
	"./eocean.png": 88021,
	"./eocean.svg": 16075,
	"./firebase.svg": 97433,
	"./infobip.png": 23371,
	"./klaviyo.png": 18431,
	"./messagebird.svg": 52090,
	"./plivo.png": 5066,
	"./sendgrid.svg": 3456,
	"./sinch.png": 6189,
	"./twilio.svg": 86318,
	"./whatsapp.svg": 5824,
	"./xpush.png": 68566
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1699;